exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-dialog {\r\n\tbackground-color: white;\r\n\tpadding: 24px;\r\n\tborder-radius: 5px;\r\n\ttext-align: center;\r\n}\r\n\r\n.button-layout {\r\n\tcolor: #262944;\r\n\twidth: 92%;\r\n\tfont-weight: bold;\r\n\tbackground-color: #41D78C;\r\n}\r\n\r\n.alert-error{\r\n\tfont-size: 14px;\r\n}\r\n\r\np{\r\n\tfont-size: 14px;\r\n\tcolor: #262944;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/resources/components/notifications/notifications.component.css
// module id = ../../../../../src/app/resources/components/notifications/notifications.component.css
// module chunks = main